import {React, classNames, useAsObservableSource, useLocalStore, observer, toJS} from '@api'
import {useStores} from '@modules/VipLocalStore'
import {site} from '@stores'
import {LazyImage} from 'centric-ui-components'
import * as css from './ProductSkeleton.css'
import {Comment, MoreHoriz} from '@material-ui/icons'

interface MyProps {
  product?: any
  className?: string
  showTitle?: boolean
}

/**
 * Lighterweight product card without support for drag and drop or other advanced functionality.  Used when loading data or - if configured - scrolling.
 */
export const ProductSkeleton = observer<MyProps>((props) => {
  const {className} = props
  const observableProps = useAsObservableSource(props)
  const store = useLocalStore(() => ({
    /* get imageUrl() {
       if (!stores.dashboard) return null

       const {dashboard: {imageSpec}} = stores, {product} = observableProps
       if (!imageSpec || imageSpec == 'products') {
         if (product.images && product.images.length > 0) {
           return product.images[0]
         }
       } else {
         let spec = product[imageSpec];
         if (spec) {
           if (spec.hex) {
             return spec.hex;
           } else {
             return spec.images && !_.isEmpty(spec.images) ? spec.images[0] : undefined
           }
         }
       }

       return null;
     },*/
    get cardView() { return this.catalog.visibleCardFields }
  }))

  const {product} = observableProps

  return (
    <div className={classNames(css.cardSkeleton, className)}>
      {product.active === false && <div className={css.diagonal}/>}
      {/*imageUrl ?
       (imageUrl.startsWith('#') ? <div className={css.hex} style={{backgroundColor: imageUrl}}/>
                                 : <img src={imageUrl} className={classNames(css.image, {[css.inactive]: !product.active})}/>)  :  */}
      <div className={classNames(css.placeHolder, {[css.inactive]: !product.active})}>
        <LoadingImagePlaceholder/>
      </div>
      {/* Don't show fields during skeleton load as they're blank, the fields are dynamic, and we load much faster now in ES.  We also no longer need the skeleton for measuring things */}
      <div className={classNames(css.footer, {[css.inactive]: !product.active})}>
        {product.showComments === true && <div className={css.iconWrapper}>
			<Comment className={classNames(css.icon, css.message)}/>
		</div>}
        <div className={css.iconWrapper}>
          <MoreHoriz className={css.icon}/>
        </div>
      </div>
    </div>
  )
})

ProductSkeleton.defaultProps = {product: {title: '', active: true}}

export const LoadingImagePlaceholder = observer(function LoadingImagePlaceholder() {
  const {catalog: {placeholderImg}} = useStores()

  return <span className={classNames(css.loadingImage)}>{placeholderImg ? <LazyImage src={placeholderImg}/> : <span className={css.blank}/>}</span>
})

export const NoImagePlaceholder = observer<{ className?: string, levelOfDetail?: number, placeholderImg?: string, placeholderText?: string, draggable?: boolean }>(
  function NoImagePlaceholder(props) {
  const {ui, catalog} = useStores(),
    placeholderImg = props.placeholderImg || catalog.placeholderImg

  //getting the placeholder image as base64 url or media url, so getting the img type based on that
  const imgType = placeholderImg ? 
                  (
                    _.includes(placeholderImg, "data:image/") ? placeholderImg.substring("data:image/".length, placeholderImg.indexOf(";base64"))
                    : placeholderImg.split('.').pop()
                  ) 
                  : ''

  return (
    <span data-type='NoImagePlaceholder' className={classNames(css.noImage, props.className)} style={toJS(ui?.settings?.noImagePlaceholderStyle ?? {})}>
    {placeholderImg ? <LazyImage src={placeholderImg} data-type={imgType} draggable={props.draggable === true}/>
    : (props.placeholderText ?? 'No Image')}
  </span>)
})



// WEBPACK FOOTER //
// ./src/modules/catalog/product/productCard/components/ProductSkeleton.tsx